module.exports = __webpack_public_path__ + "img/list_alt.86284ad7.svg";